module.exports = __webpack_public_path__ + "img/faq-poly2.612fb277.svg";